var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { PDFGenContext, PDFGenProvider } from "./PDFGenerator";
import { api } from "../../api/API";
import { EventEmitter, sleep } from "nate-react-api-helpers";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, LinearProgress, Typography } from "@mui/material";
import { DebugPDF } from "./DebugPDF";
import { makeConfigurator } from "./PrintParallel";
import { useSyncedRef } from "./PageContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultFx = function () { };
export var PrintManagerContext = /*#__PURE__*/ createContext({ print: defaultFx, print2: defaultFx, debug: defaultFx, debug2: defaultFx, interceptorRef: { current: null } });
export var printStatus = new EventEmitter();
export function PrintManagerProvider(props) { return /*#__PURE__*/ _jsx(PDFGenProvider, { children: /*#__PURE__*/ _jsx(PrintManagerProviderInner, { children: props.children }) }); }
var debugEmitter = new EventEmitter();
function PrintManagerProviderInner(props) {
    var _this = this;
    var printer = useContext(PDFGenContext);
    var print = useSyncedRef(printer.print);
    var interceptorRef = useRef(null);
    var print1 = useCallback(function (name, render, serverInfo) { return __awaiter(_this, void 0, void 0, function () { var content, rs, info, st, e_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                printStatus.emit({ status: "Rendering...", show: true, error: false, done: false });
                return [4 /*yield*/, print.current(render, makeConfigurator(serverInfo || {}, function (v) { serverInfo = v; }))];
            case 1:
                content = _a.sent();
                if (interceptorRef.current) {
                    rs = interceptorRef.current(content);
                    if (rs.cancel) {
                        printStatus.emit({ done: true, show: false });
                        return [2 /*return*/];
                    }
                }
                printStatus.emit({ status: "Packaging..." });
                return [4 /*yield*/, api.print.print({ content: content, name: name, args: serverInfo ? JSON.stringify(serverInfo) : "" })];
            case 2:
                info = _a.sent();
                _a.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, sleep(500)];
            case 4:
                _a.sent();
                return [4 /*yield*/, api.print.getStatus({ uuid: info.uuid })];
            case 5:
                st = _a.sent();
                printStatus.emit({ status: st.status });
                if (st.failed) {
                    printStatus.emit({ error: true, done: true });
                    return [2 /*return*/];
                }
                if (st.ready) {
                    api.print.download({ uuid: info.uuid });
                    printStatus.emit({ done: true, show: false });
                    return [2 /*return*/];
                }
                return [3 /*break*/, 3];
            case 6: return [3 /*break*/, 8];
            case 7:
                e_1 = _a.sent();
                console.error(e_1);
                printStatus.emit({ status: e_1.toString(), show: true, error: true, done: true });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    }); }); }, [print]);
    var ctx = useMemo(function () { return ({ debug: function (name, render, serverInfo) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            debugEmitter.emit({ render: render });
            return [2 /*return*/];
        }); }); }, print2: function (input) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, print1(input.name, input.render, input.serverInfo)];
        }); }); }, print: print1, debug2: function (input) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            debugEmitter.emit({ render: input.render });
            return [2 /*return*/];
        }); }); }, interceptorRef: interceptorRef }); }, [print1]);
    return /*#__PURE__*/ _jsxs(PrintManagerContext.Provider, { value: ctx, children: [props.children, /*#__PURE__*/ _jsx(PrintManagerStatus, {}), /*#__PURE__*/ _jsx(PrintDebugManager, {})] });
}
function PrintDebugManager(props) { var _a = useState(), debug = _a[0], setDebug = _a[1]; useEffect(function () { var sub = debugEmitter.subscribe(function (value) { setDebug(value); }); return function () { return sub.cancel(); }; }, []); if (!debug)
    return null; var render = debug.render; return /*#__PURE__*/ _jsx(DebugPDF, { render: function (v) { return render(v, makeConfigurator({}, function () { })); }, onClose: function () { return setDebug(undefined); } }); }
export function PrintManagerStatus(props) { var _a = useState({ status: "", done: false, show: false, error: false }), state = _a[0], setState = _a[1]; useEffect(function () { var sub = printStatus.subscribe(function (update) { console.log(update); setState(function (old) { return Object.assign({}, old, update); }); }); return function () { return sub.cancel(); }; }, []); var update = useCallback(function (update) { setState(function (old) { return Object.assign({}, old, update); }); }, []); if (!state.show)
    return null; var complete = state.error || state.done; return /*#__PURE__*/ _jsxs(Dialog, { open: true, maxWidth: "sm", fullWidth: true, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: state.error ? "Print Failed" : "Printing" }), /*#__PURE__*/ _jsx(DialogContent, { children: /*#__PURE__*/ _jsx(DialogContentText, { children: /*#__PURE__*/ _jsxs(Grid, { container: true, spacing: 1, direction: "column", children: [!complete ? /*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(LinearProgress, { variant: "indeterminate" }) }) : null, /*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(Typography, { variant: "body1", color: "initial", children: state.status }) })] }) }) }), /*#__PURE__*/ _jsx(DialogActions, { children: /*#__PURE__*/ _jsx(Button, { onClick: function () { return update({ show: false }); }, children: "Close" }) })] }); }
